



























































import { Component, Prop, Mixins } from 'vue-property-decorator'
import OzButton from 'library/v4/components/OzButton.vue'
@Component({ components: { OzButton } })
export default class SurfacePostAttachmentEmbedControl extends Mixins() {
  @Prop() colorScheme!: 'light' | 'dark'
  @Prop() isDownloadable!: boolean
  @Prop() downloadUrl!: string

  get isDarkColorScheme(): boolean {
    return this.colorScheme === 'dark'
  }
}
